// useAutoFontResize.js
import { useEffect, useRef } from 'react';

function adjustFontSizeByTextLength(el, max = 20, min = 12) {
  if (!el) return;

  const length = el.textContent.length;
  const windowWidth = window.innerWidth;

  let size = max;

  // Shrink for longer text
  if (length > 5) size -= 0;
  if (length > 10) size -= 2;
  if (length > 25) size -= 3;
  if (length > 45) size = min;

  // Further shrink on small screens
  if (windowWidth < 768 && length > 5) size -= 0;
  if (windowWidth < 480 && length <= 5) size -= 0;
  if (windowWidth < 480 && length > 5) size -= 2;


  size = Math.max(min, Math.min(size, max));
  el.style.fontSize = `${size}px`;
}

export function useAutoFontResize(label, max = 20, min = 12) {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const resize = () => adjustFontSizeByTextLength(el, max, min);
    resize(); // run on mount

    const observer = new ResizeObserver(resize);
    observer.observe(document.body); // You can also observe `el` if only element resize matters

    window.addEventListener('resize', resize);

    return () => {
      observer.disconnect();
      window.removeEventListener('resize', resize);
    };
  }, [label, max, min]);

  return ref;
}
